/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2023. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { SET_USER_INPUT_TYPE, SET_USER_INPUT_VALIDATION_ERRORS_TYPE } from './actionTypes';

/**
 * Updates the details in the 'SampleModule' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const updatePasswordResetFormReducer = (state = {}, action) => {
  if (action.type === SET_USER_INPUT_TYPE) {
    // console.log("My Reducer was called for state update on UserInput")
    return { userInput: action.payload, validationErrors: state.validationErrors };
  }
  if (action.type === SET_USER_INPUT_VALIDATION_ERRORS_TYPE) {
    // console.log("My Reducer was called for state update on UserInput")
    return { userInput: state.userInput, validationErrors: action.payload };
  }

  return state;
};

const reducers = combineReducers({
  passwordResetForm: updatePasswordResetFormReducer,
});

export default { reducers };
